import type { StateCorrectionReview, TierIIStateReporting } from '../../tri-shared/types/tierii-state-fields.ts';

/** Preserve reusable documents and state-keyed answers, but re-ask applicability after a correction. */
export function applyStateCorrection(
  reporting: TierIIStateReporting,
  review: StateCorrectionReview,
): TierIIStateReporting {
  const changed = reporting.stateCorrectionReview?.id !== review.id;
  return {
    ...reporting,
    ...(changed ? { applicability: {}, productSdsApplicability: {} } : {}),
    stateCorrectionReview: review,
  };
}

export function preserveStateCorrection(
  saved: TierIIStateReporting | null,
  incoming: TierIIStateReporting,
): TierIIStateReporting {
  const { stateCorrectionReview: _untrusted, ...answers } = incoming;
  if (!saved?.stateCorrectionReview) return answers;
  const current = saved.stateCorrectionReview;
  return {
    ...answers,
    ...(incoming.stateCorrectionReview?.id !== current.id
      ? { applicability: saved.applicability, productSdsApplicability: saved.productSdsApplicability }
      : {}),
    stateCorrectionReview: current,
  };
}
